import { createRoutesFromElements, Route, Outlet } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminProtectedRoute } from "@/components/auth/AdminProtectedRoute";
import { AppLayout } from "@/components/layout/AppLayout";
import Index from "./pages/Index";
import Dashboard from "./pages/Dashboard";
import BrainTraining from "./pages/BrainTraining";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import SubjectProgress from "./pages/SubjectProgress";
import Practice from "./pages/Practice";
import TakeExam from "./pages/TakeExam";
import Profile from "./pages/Profile";
import LetsPractice from "./pages/LetsPractice";
import UserLogs from "./pages/UserLogs";
import AvatarCreator from "./pages/AvatarCreator";
import { TestimonialForm } from "./components/testimonials/TestimonialForm";
import ManageSubscription from "./pages/subscription/ManageSubscription";
import AboutUs from "./pages/AboutUs";
import QuestionBank from "./pages/QuestionBank";
import GameData from "./pages/GameData";
import { SignUp } from "./pages/SignUp";
import { AdminTab } from "./components/dashboard/admin/AdminTab";
import { ManageQuestions } from "./components/dashboard/admin/ManageQuestions";
import { HomePageEditor } from "./components/dashboard/admin/HomePageEditor";

const AppLayoutRoute = () => (
  <AppLayout>
    <Outlet />
  </AppLayout>
);

const AuthLayout = () => (
  <div className="min-h-screen w-full flex flex-col items-center justify-center p-4 relative overflow-hidden bg-gradient-to-b from-white to-[rgba(30,174,219,0.02)]">
    <Outlet />
  </div>
);

const AdminLayout = () => (
  <>
    <Outlet />
  </>
);

export const routes = createRoutesFromElements(
  <Route id="routes">
    <Route id="index" path="/" element={<Index />} />
    <Route id="auth" path="/auth" element={<AuthLayout />}>
      <Route index element={<Auth />} />
    </Route>
    <Route id="signup" path="/signup" element={<SignUp />} />
    <Route id="about" path="/about" element={<AboutUs />} />
    
    <Route element={<AppLayoutRoute />}>
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/brain-training" element={<BrainTraining />} />
        <Route path="/subject-progress" element={<SubjectProgress />} />
        <Route path="/practice" element={<Practice />} />
        <Route path="/take-exam" element={<TakeExam />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/user-logs" element={<UserLogs />} />
        <Route path="/avatar-creator" element={<AvatarCreator />} />
        <Route path="/manage-subscription" element={<ManageSubscription />} />
        <Route path="/question-bank" element={<QuestionBank />} />
        <Route path="/game-data" element={<GameData />} />
        <Route path="/lets-practice" element={<LetsPractice />} />
      </Route>

      <Route path="/admin" element={<AdminLayout />}>
        <Route path="" element={
          <AdminProtectedRoute>
            <AdminTab />
          </AdminProtectedRoute>
        } />
        <Route path="homepage-editor" element={
          <AdminProtectedRoute>
            <HomePageEditor />
          </AdminProtectedRoute>
        } />
        <Route path="manage-questions" element={
          <AdminProtectedRoute>
            <ManageQuestions />
          </AdminProtectedRoute>
        } />
      </Route>
    </Route>

    <Route path="*" element={<NotFound />} />
  </Route>
);